import React, { useEffect, useState } from 'react'
import { Col, Row } from "reactstrap";
import {connect} from "react-redux";


// services
import {wishlistService} from "../../../jwt/_services/todoFluye/wishlistService";

// utils
import { geWishlistTotalOption } from "../../../util/WishlistUtils";


const WishlistTotales = (props) => {
    const { pageSize, pageIndex, filter, reload } = props.listState

    const [totals, setTotals] = useState([])

   useEffect(() => {
        if(!filter)
            return

        getTotals()
    },[pageSize, pageIndex, filter, reload])

    const getTotals = () => wishlistService.totals(pageIndex, pageSize, filter)
        .then( data => {
            if(!data)
                return

            setTotals( data )
        })
        .catch( console.log )

    return <div className={'wl-totals-section mb-2em'}>
        {
            totals.map((total, i) => {
                const option = geWishlistTotalOption( total?.code )

                return <div key={`total-${i}`} className={ `wl-totals-container ${option?.style}` }>
                    <Row>
                        <Col>
                            <label className={'total'}>{total?.total}</label>
                            <label className={'title'}>{option?.title}</label>
                        </Col>
                    </Row>
                </div>
            })
        }
    </div>
}

const mapStateToProps = state => ({ listState : state.listProps, })
const mapActionsToProps = ({})

export default connect(mapStateToProps, mapActionsToProps)(WishlistTotales)